<template>
  <template v-if="editionMode">
    <SelectComponent
      v-model="selectedValues"
      :multiple="multiple"
      :searchable="searchable"
      :name="name"
      :values="orderedUser"
      :label="label"
      display-key="full_name"
      :required="required"
      :edition-mode="editionMode"
      :errors="errors"
    />
  </template>
  <BaseShowLabel v-else :label="label" :model-value="selectedLabel" />
</template>

<script>
import { mapGetters } from 'vuex'
import { computed } from 'vue'
import SelectComponent from '@c/BaseFormComponent/SelectComponent'
import BaseShowLabel from '@c/addf-package/components/BaseLabel/BaseShowLabel.vue'

export default {
  name: 'SelectUser',
  components: { BaseShowLabel, SelectComponent },
  props: {
    editionMode: {
      type: Boolean,
      required: true
    },
    searchable: {
      type: Boolean,
      required: false,
      default: false
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false
    },
    errors: {
      type: Array,
      required: false,
      default: () => []
    },
    modelValue: {
      type: [Array, Number],
      required: true
    },
    label: {
      type: String,
      required: false,
      default: null
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    name: {
      type: String,
      required: true
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const selectedValues = computed({
      get: () => props.modelValue,
      set: (value) => emit('update:modelValue', value)
    })
    return { selectedValues }
  },
  computed: {
    ...mapGetters('metadata', { users: 'getUsersMetadata' }),
    orderedUser() {
      return this.users.sort((a, b) => a.full_name.localeCompare(b.full_name))
    },
    selectedLabel() {
      return this.users.find((user) => user.id === this.modelValue)?.full_name
    }
  }
}
</script>
